import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setNavigateFunction } from "./NavigationUtils";

/**
 * NavigationService component that makes navigation available globally
 * This component should be placed early in your app tree, inside a Router
 */
export const NavigationService: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Set the navigate function for global access
    setNavigateFunction(navigate);

    // Cleanup: clear the navigate function when component unmounts
    return () => {
      setNavigateFunction(null);
    };
  }, [navigate]);

  // This component renders nothing visible
  return null;
};
